'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamIcon = require('./CamIcon');

var _CamIcon2 = _interopRequireDefault(_CamIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamIcon/index.js
// module id = 170
// module chunks = 0